export const DISPLAY_SUCCESSFUL_SWITCH_TENANT_TOASTER =
  '@project44/um-ui/display-successful-switch-tenant-toaster';

export const UPDATE_USER_QUERY = '@project44/um-ui/update-user-query';
